import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HighSchoolPage from "../pages/highschool/page";
import CounselingPage from "../pages/counseling/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/high-school",
    element: <HighSchoolPage />,
  },
  {
    path: "/counseling",
    element: <CounselingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;